// extracted by mini-css-extract-plugin
export default {"globalDropdown":"mYux0TdwhAwOYWsu9ZhY"};